export const POSTHOG_DISTINCT_ID_COOKIE = "ph_distinct_id"
